import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ListPanel from '../../../components/list-panel/ListPanel';
import RESTService from '../../../services/RESTService';
import CommonService from '../../../services/CommonService';
import TimeAgo from '../../../../node_modules/react-timeago/lib/index';
import MonacoEditor from 'react-monaco-editor';
import Spinner from '../../../components/spinner/Spinner';
import CreateDefinitionModal from '../create-definition-modal/CreateDefinitionModal';
import DialogModal from '../../../components/dialog-modal/DialogModal';
import RoutingService from '../../../services/RoutingService';
const connect = new RESTService();
const CS = new CommonService();
const RS = new RoutingService();

class AppDefPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			definitions: [],
			defMap: {},
			loading: true,
			editing: false,
			searchText: '',
			toEdit: {},
			defDetails: {},
			createOpen: false,
			showDeleteModal: false,
			toDelete: null,
			showPublishModal: false,
			validJson: true
		};
		this.editor = null;
		this.autoBind([
			'onCreate',
			'onBack',
			'onSave',
			'onCloseCreate',
			'onDelete',
			'buildDefList',
			'onSearchChange',
			'onDefinitionClick',
			'updateDimensions',
			'handleEditorDidMount',
			'handleDefinitionsChange',
			'onCreationComplete',
			'editDefinition',
			'getDefinitions',
			'toggleDeleteModal',
			'onConfirmDelete',
			'publishDefinition',
			'onConfirmPublish',
			'togglePublishModal'
		]);
	}

	toggleDeleteModal() {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	}

	publishDefinition(evt) {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let def = this.data.defMap[id];
			if (def) {
				this.setData('toPublish', def);
				this.togglePublishModal();
			}
		}
	}

	onConfirmPublish() {
		this.togglePublishModal();
		this.data.toPublish.published = true;
		connect.updateAppDef(this.data.toPublish).then(() => {
			RS.showSuccess();
			this.getDefinitions();
		});
	}

	togglePublishModal() {
		this.setData('showPublishModal', !this.data.showPublishModal);
	}

	onConfirmDelete() {
		connect
			.deleteAppDef(this.data.toDelete)
			.then(() => {
				this.toggleDeleteModal();
				this.getDefinitions();
				RS.showSuccess();
			})
			.catch(err => {
				this.toggleDeleteModal();
				RS.smartError(err);
			});
	}

	onSearchChange(evt) {
		this.setData('searchText', evt.target.value);
	}

	onCreate() {
		this.setData('createOpen', true);
	}

	onCloseCreate() {
		this.setData('createOpen', false);
	}

	onCreationComplete(newDef) {
		this.onCloseCreate();
		this.editDefinition(newDef);
	}

	onDelete(evt) {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let def = this.data.defMap[id];
			if (def) {
				this.setData('toDelete', def);
				this.toggleDeleteModal();
			}
		}
	}

	onBack() {
		this.observe(() => {
			this.data.editing = false;
			this.data.loading = true;
		});
		this.getDefinitions();
	}

	onSave() {
		let def = JSON.parse(this.data.toEdit);
		connect.updateAppDef({ ...def, ...this.data.defDetails }).then(res => {
			RS.showSuccess();
			console.log(res);
		});
	}

	handleEditorDidMount(editor) {
		this.editor = editor;
		// setTimeout(() => {
		// 	this.editor.getAction('editor.action.formatDocument').run();
		// }, 200);
	}

	editDefinition(def) {
		this.observe(() => {
			this.data.editing = true;
			this.data.defDetails = {
				name: def.name,
				_id: def._id,
				displayName: def.displayName,
				version: def.version,
				creationDate: def.creationDate,
				updateDate: def.updateDate,
				published: def.published
			};
			this.data.published = def.published;

			delete def.name;
			delete def._id;
			delete def.displayName;
			delete def.version;
			delete def.creationDate;
			delete def.updateDate;
			delete def.published;

			this.data.toEdit = JSON.stringify(def, undefined, 2);
			this.data.definitions = [];
		});
	}

	onDefinitionClick(evt) {
		if (evt.target.classList.contains('action') || evt.target.classList.contains('mdi') || evt.target.classList.contains('btn')) {
			return;
		}
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let def = this.data.defMap[id];
			if (def) {
				this.editDefinition(def);
			}
		}
	}

	handleDefinitionsChange(newValue) {
		let decorations = this.editor.getModel().getAllDecorations();
		let error = decorations
			.filter(decorations => {
				return decorations.options.className === 'redsquiggly';
			})
			.map(e => e);
		this.observe(() => {
			this.data.toEdit = newValue;
			this.data.validJson = error.length <= 0;
		});
		setTimeout(() => {
			let decorations = this.editor.getModel().getAllDecorations();
			let error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.validJson = error.length <= 0;
			});
		}, 1500);
	}

	getDefinitions() {
		connect
			.getAppDefs()
			.then(res => {
				this.observe(() => {
					this.data.definitions = res.data;
					this.data.defMap = CS.mapByParam('_id', res.data);
					this.data.loading = false;
				});
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
	}

	componentDidMount() {
		this.getDefinitions();
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
	}

	updateDimensions() {
		//automaticLayout is an alternative fix but it uses an interval so has very bad performance impact
		if (this.editor && this.editor.domElement) {
			this.editor.layout({ width: this.editor.domElement.offsetWidth - 10, height: this.editor.domElement.offsetHeight });
		}
	}

	buildDefList() {
		let defs = this.data.definitions;
		if (this.data.loading) {
			return <Spinner text="Loading Definitions" />;
		}
		if (defs.length <= 0) {
			return <div className="empty-list">This platform has no definitions yet.</div>;
		}
		let items = [];
		for (let i = 0; i < defs.length; i++) {
			let def = defs[i];
			if (def.displayName.toLowerCase().indexOf(this.data.searchText.toLowerCase()) >= 0) {
				items.push(
					<div className="list-item hbox vcenter animated fadeInDown" key={'list-item-' + def._id} data-id={def._id} onClick={this.onDefinitionClick}>
						<div className="list-value ellipse grow-1">{def.displayName}</div>
						<div className="list-value ellipse grow-1">
							<TimeAgo date={def.updateDate ? def.updateDate : def.creationDate} />
						</div>
						<div className="list-value ellipse grow-1">
							<div className="version">{def.version}</div>
						</div>
						<div className="actions hbox vcenter grow-1">
							<div className="action vbox hcenter vcenter" data-rh="Delete Definition" data-rh-at="top" data-id={def._id} onClick={this.onDelete}>
								<i className="mdi mdi-delete" data-id={def._id} />
							</div>
							{!def.published && (
								<button className="btn small yellow" onClick={this.publishDefinition} data-id={def._id}>
									Publish
								</button>
							)}
							{def.published && <div className="btn small green">Published</div>}
						</div>
					</div>
				);
			}
		}
		return items;
	}

	render() {
		let { editing, toEdit, defDetails, createOpen, showDeleteModal, showPublishModal, published, validJson } = this.data;
		if (!editing) {
			return (
				<div className="app-definitions-panel-view animated fadeIn">
					<div className="app-definitions-panel-header hbox vcenter hright">
						<div className="search-ctn hbox vcenter">
							<i className="mdi mdi-magnify" />
							<input className="search-input" value={this.data.searchText} onChange={this.onSearchChange} placeholder="Search Definitions..." />
						</div>
					</div>
					<ListPanel
						name="Application Definitions List"
						className="app-def-list-view"
						labels={['name', 'updated', 'version', 'actions']}
						onCreate={this.onCreate}
						listItems={this.buildDefList()}
					/>
					<CreateDefinitionModal isOpen={createOpen} onClose={this.onCloseCreate} onComplete={this.onCreationComplete} />
					<DialogModal
						isOpen={showDeleteModal}
						type="warning"
						showCancelButton={true}
						cancelBtnText="Cancel"
						confirmBtnText="Delete"
						text="Deleting a definition cannot be undone"
						title="Are you sure?"
						onConfirm={this.onConfirmDelete}
						onCancel={this.toggleDeleteModal}
					/>
					<DialogModal
						isOpen={showPublishModal}
						type="warning"
						showCancelButton={true}
						cancelBtnText="Cancel"
						confirmBtnText="Publish"
						text="Publishing a definition cannot be undone"
						title="Are you sure?"
						onConfirm={this.onConfirmPublish}
						onCancel={this.togglePublishModal}
					/>
				</div>
			);
		} else if (editing) {
			return (
				<div className="app-definitions-panel-view animated fadeIn">
					<div className="editor-title">
						Editing: {defDetails.displayName} v-{defDetails.version}
					</div>
					<div className="app-def-editor-view">
						<MonacoEditor
							language="json"
							theme="vs-dark"
							value={toEdit}
							options={{ folding: true }}
							editorDidMount={this.handleEditorDidMount}
							onChange={this.handleDefinitionsChange}
						/>
					</div>
					<div className="app-definitions-panel-footer hbox vcenter">
						<div className="title grow-1" />
						<button className="btn m-r-20" onClick={this.onBack}>
							Back
						</button>
						{!published && (
							<button className="btn primary m-r-20" onClick={this.onSave} disabled={!validJson}>
								Save
							</button>
						)}
					</div>
				</div>
			);
		}
	}
}

export default AppDefPanel;



// WEBPACK FOOTER //
// ./src/views/application-builder/app-def-panel/AppDefPanel.js